import React from 'react';
import {List, ListItemIcon, ListItemText, ListItemButton, Box} from '@mui/material';
import Icon from './Icon';

import { NavLink } from 'react-router-dom';


interface SidebarProps {
    onLogoClick: () => void;
    onCloseMenuClick: () => void;
}


const Sidebar: React.FC<SidebarProps> = ({onLogoClick, onCloseMenuClick}) => {

    return (
        <List>
            <Box className='menuLogo' onClick={onLogoClick}>
                <img src="/horisontalLogo.svg" className='horisontalLogo' alt=""/>
            </Box>
            <ListItemButton onClick={onCloseMenuClick} component={NavLink} to="/" end>
                <ListItemIcon><Icon name="home" /></ListItemIcon>
                <ListItemText primary="Статистика" />
            </ListItemButton>
            <ListItemButton onClick={onCloseMenuClick} component={NavLink} to="/quiz1">
                <ListItemIcon><Icon name="stat" /></ListItemIcon>
                <ListItemText primary="Уротелиальный рак" />
            </ListItemButton>
            <ListItemButton onClick={onCloseMenuClick} component={NavLink} to="/quiz2">
                <ListItemIcon><Icon name="stat" /></ListItemIcon>
                <ListItemText primary="Рак почки" />
            </ListItemButton>
            <ListItemButton onClick={onCloseMenuClick} component={NavLink} to="/quiz3">
                <ListItemIcon><Icon name="stat" /></ListItemIcon>
                <ListItemText primary="Колоректальный рак" />
            </ListItemButton>
            <ListItemButton onClick={onCloseMenuClick} component={NavLink} to="/quiz4">
                <ListItemIcon><Icon name="stat" /></ListItemIcon>
                <ListItemText primary="Рак головы и шеи" />
            </ListItemButton>
            <ListItemButton onClick={onCloseMenuClick} component={NavLink} to="/profile">
                <ListItemIcon><Icon name="profile" /></ListItemIcon>
                <ListItemText primary="Профиль" />
            </ListItemButton>
        </List>
    );
};

export default Sidebar;
